import { useRef } from 'react';
import { shallowEqual } from 'react-redux';

/**
 * Similar to `usePrevious`, but will keep returning the old reference until the value shallow
 * changes.
 */
export function usePreviousUntilChanged<T>(next: T): T {
  const previous = useRef<T>(next);

  if (shallowEqual(previous.current, next)) {
    return previous.current;
  }

  previous.current = next;
  return next;
}
